import { Grid, useMediaQuery, useTheme } from '@mui/material';
import Left from './Left';
import Right from './Right';
import NavBar from './NavBar';
import { useLocation } from 'react-router-dom';
import MobileLayout from './MobileLayout';

const Main = function () {
  const theme = useTheme();
  const { pathname } = useLocation();
  const isLeftOpen = pathname.split('/').length < 3;
  const currentView = isLeftOpen ? 'left' : 'right';
  const isSm = useMediaQuery(theme.breakpoints.down('lg'));
  console.log('current', currentView);
  return (
    <Grid container sx={{ height: '100%' }}>
      {isSm ? (
        <>
          <MobileLayout/>
        </>
      ) : (
        <>
          <Left />
          <Grid
            item
            xs={12}
            lg={9.5}
            container
            sx={{
              flex: 1,
              p: 1,
              pl: 0,
              display: 'grid',
              gridTemplateRows: '70px 1fr',
              height: '100%',
              width: '100%',
              [theme.breakpoints.down('lg')]: {
                display: currentView === 'right' ? 'grid' : 'none',
                p: 1,
              },
            }}
          >
            <NavBar />
            <Right />
          </Grid>
        </>
      )}
    </Grid>
  );
};

export default Main;
